// src/filters/filters.js

import Vue from 'vue';
import moment from 'moment-timezone';

moment.tz.setDefault('America/Santiago');
require('moment/locale/es');


Vue.filter('toDateTime', function (date) {
    if (!date) return "";
    return moment(date).format("YYYY-MM-DD HH:mm");
});

Vue.filter('toDate', function (date) {
    if (!date) return "";
    return moment(date).format("YYYY-MM-DD");
});

// Redondeo a 2 decimales (por defecto) 
// {{ 1.23456 | Round }}  1.23 
// Redondeo a 3 decimales 
// {{ 1.23456 | Round(3) }}  1.235 
Vue.filter('Round', function (value, decimals = 2) {
    const number = parseFloat(value);
    if (isNaN(number)) return 0;
    const factor = Math.pow(10, decimals);
    return Math.round((number + Number.EPSILON) * factor) / factor;
});

Vue.filter('FormatToDate', function (date) {
    if (!date) return "";
    return moment(date).format("DD/MM/YYYY");
});

Vue.filter('FormatToTime', function (date) {
    if (!date) return "";
    return moment(date).format("HH:mm");
});

Vue.filter('FormatToYear', function (date) {
    if (!date) return "";
    return moment(date).format("YYYY");
});

Vue.filter('FormatToDateTime', function (date) {
    if (!date) return "";
    return moment(date).format("DD/MM/YYYY HH:mm");
});
Vue.filter('FormatToTimeDate', function (date) {
    if (!date) return "";
    return moment(date).format("HH:mm DD/MM/YYYY");
});

Vue.filter('FormatToFullDateEsp', function (date) {
    if (!date) return "";
    return moment(date).format('dddd, D [de] MMMM [de] YYYY');
});

